module.exports = __webpack_public_path__ + "static/img/fullBody3.6be0a68e.png";